/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DamEventService {

  private damUploadFinish$ = new BehaviorSubject<boolean>(false);

  getDamUploadFinish(): Observable<boolean> {
    return this.damUploadFinish$.asObservable();
  }

  nextDamUploadFinish(value: boolean) {
    this.damUploadFinish$.next(value);
  }

}
